import React, { useRef, useLayoutEffect } from 'react';
import { Paper, Box, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export default function StatCard({ icon, label, value, change, changeDir, color, sx, onOverflow }) {
  const contentRef = useRef();

  useLayoutEffect(() => {
    if (contentRef.current && onOverflow) {
      setTimeout(() => {
        if (!contentRef.current) return;
        const isOverflowing = contentRef.current.scrollWidth > contentRef.current.clientWidth;
        onOverflow(isOverflowing);
      }, 0);
    }
  }, [label, value, sx, onOverflow]);

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        p: { xs: 1.5, sm: 2.5 },
        display: "flex",
        alignItems: "center",
        gap: { xs: 1, sm: 2 },
        flexDirection: "row",
        boxShadow: "0px 2px 16px rgba(80, 120, 220, 0.07)",
        bgcolor: "#fff",
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        ...sx,
      }}
    >
      <Box sx={{
        bgcolor: color + ".light",
        color: color + ".main",
        borderRadius: "50%",
        p: { xs: 0.7, sm: 1.2 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: { xs: 23, sm: 28 },
      }}>
        {icon}
      </Box>
      <Box ref={contentRef} sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
        <Typography
          variant="overline"
          sx={{
            fontWeight: 700,
            fontSize: { xs: 12, sm: 13 },
            color: "#555",
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            lineHeight: 1.1,
            fontSize: { xs: 20, sm: 24 }
          }}
        >
          {value}
        </Typography>
        {change !== undefined && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.3,
            mt: 0.3,
            flexWrap: 'wrap'
          }}>
            {changeDir === 'up'
              ? <ArrowUpwardIcon color="success" fontSize="small" />
              : <ArrowDownwardIcon color="error" fontSize="small" />
            }
            <Typography variant="caption" color={changeDir === 'up' ? 'success.main' : 'error.main'}>
              {change}
            </Typography>
            <Typography variant="caption" sx={{ ml: 0.3, color: "#aaa" }}>
              Since last month
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}